class CollectionQuiz extends window.BAO.CustomElement() {
  constructor () {
    super()
    this._quizItemEls = this.els?.quizItem || []
  }

  setupListeners () {
    window.addEventListener(
      'quiz:updateFilters',
      this.updateKlevuFilters.bind(this),
    )
  }

  updateKlevuFilters (e) {
    const klevu = window.klevu || false

    if (!klevu) return

    const searchArea = document.querySelector('.kuCategoryPageContainer')

    if (searchArea === null) return

    const searchInput = searchArea.kElem

    searchInput.kScope.data = searchInput.kObject.resetData(searchInput.kElem)
    searchInput.kScope.data.context.keyCode = 0
    searchInput.kScope.data.context.eventObject = e
    searchInput.kScope.data.context.event = 'keyUp'
    searchInput.kScope.data.context.preventDefault = !1

    const productList = document.querySelector('.productList.klevuMeta')

    if (productList === null) return

    const request = [
      {
        key: 'tags',
        settings: {
          singleSelect: 'false',
        },
        values: this.selectedAnswers,
      },
    ]

    this.submitKlevuFilterRequest(klevu, searchInput, productList, request, e)
  }

  submitKlevuFilterRequest (klevu, searchInput, productList, request, e) {
    request.length
      ? klevu.setObjectPath(
        searchInput.kScope.data,
          `localOverrides.query.${productList.dataset.section}.filters.applyFilters.filters`,
          request,
      )
      : klevu.setObjectPath(
        searchInput.kScope.data,
          `localOverrides.query.${productList.dataset.section}.filters.applyFilters`,
          {},
      )
    klevu.setObjectPath(
      searchInput.kScope.data,
      `localOverrides.query.${productList.dataset.section}.settings.offset`,
      0,
    )
    klevu.event.fireChain(
      searchInput.kScope,
      'chains.events.keyUp',
      searchInput,
      searchInput.kScope.data,
      e,
    )
  }

  get quizItemEls () {
    return this._quizItemEls
  }

  get selectedAnswers () {
    const selectedAnswers = []
    this.quizItemEls.elements.forEach(quizItem => {
      if (quizItem.selectedAnswer) {
        selectedAnswers.push(quizItem.selectedAnswer)
      }
    })
    return selectedAnswers
  }
}

class CollectionQuizItem extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.init()

    this._answersContainer = this.els?.answers?.element
    this._answerButtons = this.els?.answerButton?.elements || []
    this._selectedAnswer = false
  }

  init () {}

  setupListeners () {
    this.answerButtons.forEach(button => {
      button.addEventListener('click', this.handleButtonClick.bind(this))
    })
  }

  handleButtonClick (e) {
    const answer = e.target.dataset.value

    if (!answer) return

    if (this.selectedAnswer === answer) {
      this.selectedAnswer = false
      this.setButtonClasses(e.target, false)
      window.dispatchEvent(new CustomEvent('quiz:updateFilters'))
      return
    }

    if (this.selectedAnswer) {
      const selectedButton = this.answerButtons.find(
        button => button.dataset.value === this.selectedAnswer,
      )
      if (selectedButton) {
        this.setButtonClasses(selectedButton, false)
      }
    }

    this.selectedAnswer = answer
    this.setButtonClasses(e.target, true)
    window.dispatchEvent(new CustomEvent('quiz:updateFilters'))
  }

  setButtonClasses (item, isRefined) {
    const container = item.closest('.clc-Quiz_Answer')
    container.classList.toggle('clc-Quiz_Answer-unrefined', !isRefined)
    container.classList.toggle('clc-Quiz_Answer-refined', isRefined)

    const button = container.querySelector('.clc-Quiz_Button')
    button.classList.toggle('btn-Button-secondary', !isRefined)
    button.classList.add('btn-Button-primary', isRefined)

    if (!isRefined) {
      button.blur()
    }
  }

  get namespace () {
    return this.dataset.quizFacetAttribute
  }

  get sortOrder () {
    return this.dataset.quizSortOrder
  }

  get selectedAnswer () {
    return this._selectedAnswer
  }

  set selectedAnswer (value) {
    this._selectedAnswer = value
  }

  get exclusive () {
    return this.dataset.quizExclusive
  }

  get answersContainer () {
    return this._answersContainer
  }

  get answerButtons () {
    return this._answerButtons
  }
}

if (!customElements.get('collection-quiz')) {
  customElements.define('collection-quiz', CollectionQuiz)
}

if (!customElements.get('collection-quiz-item')) {
  customElements.define('collection-quiz-item', CollectionQuizItem)
}
